import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import FormField from '../FormField';

const Iban = React.forwardRef(
    (
        {
            config,
            pspId,
            token,
            lyriaUrl,
            hidePayButton = false,
            onPaymentResult,
        },
        ref
    ) => {
        const { t } = useTranslation();
        const formRef = React.useRef(null);
        const [errors, setErrors] = React.useState({});

        const submitForm = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const formData = new FormData(event.currentTarget);
            const data = {};
            for (let entry of formData.entries()) {
                data[entry[0]] = entry[1];
            }

            axios({
                method: 'post',
                url: lyriaUrl + '/iban/save',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    data: data,
                    request_token: token,
                    psp: pspId,
                }
            }).then(function () {
                handleSuccess();
            }).catch(function (error) {
                if (error.response.status === 400) {
                    handleError(error.response.data);
                } else {
                    console.error(error.response);
                }
            });
        };

        React.useImperativeHandle(ref, () => ({
            pay() {
                return formRef.current.click();
            }
        }));

        const handleSuccess = () => {
            onPaymentResult({ success: true });
        };

        const handleError = response => {
            setErrors(response.data);
            onPaymentResult({ success: false, data: response });
        };

        return (
            <div className="wz-lyriapay-form">
                <form noValidate onSubmit={submitForm}>
                    <div className="wz-lyriapay-flexcontainer">
                        <FormField
                            name="iban"
                            label="iban_iban"
                            errors={errors.iban}
                        />
                        {config.collect_bic && (
                            <FormField
                                name="bic"
                                label="iban_bic"
                                errors={errors.bic}
                            />
                        )}
                        <FormField
                            name="holder"
                            label="iban_holder"
                            errors={errors.holder}
                        />
                    </div>
                    <div>
                        <button
                            className="wz-lyriapay-formsubmit"
                            type="submit"
                            ref={formRef}
                            style={hidePayButton ? {
                                /*
                                note: we hide the button instead of removing it from the DOM
                                because the browser will trigger the buttonʼs onClick if we press Enter in any of the form input
                                it work if the button is hidden, it doesnʼt work if there is no button
                                */
                                display: 'none'
                            } : {}}>
                            {t('payButton')}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
);

Iban.propTypes = {
    config: PropTypes.object,
    pspId: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    lyriaUrl: PropTypes.string.isRequired,
    hidePayButton: PropTypes.bool,
    onPaymentResult: PropTypes.func.isRequired,
};

export default Iban;